import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65cb7df521b7/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65cb7df521b7/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de65cb7df521b7/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65cb7df521b7/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de65cb7df521b7/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/app/[locale]/branches/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de65cb7df521b7/node_modules/next/dist/client/link.js");
